import { CodeRoleType } from 'app/views/auth/model/types-roles-code.config';

export interface OidcLoginResponse {
  isAuthenticated: boolean;
  accessToken: string;
  expires_in?: number;
  idToken: string;
  token_type?: string;
  userData: UserData;
  configId?: string;
  access_token_expires_at?: number;
}

export interface UserData {
  agentName: string;
  cultureCode: string;
  currencyCode: string;
  organizationCode: string;
  roleCode: CodeRoleType;
  temporalPassword?: string;
  sub: number;
}

export const OidcLoginResponse: OidcLoginResponse = {
  isAuthenticated: false,
  accessToken: '',
  idToken: '',
  userData: {
    agentName: '',
    cultureCode: '',
    currencyCode: '',
    organizationCode: '',
    roleCode: 'WCAD',
    sub: 0,
    temporalPassword: ''
  },
  configId: ''
};

export const OidcLoginResponseStubby: OidcLoginResponse = {
  isAuthenticated: true,
  accessToken: 'fake-stubby-token',
  idToken: '',
  userData: {
    agentName: 'demo-user-stubby',
    cultureCode: 'es-Es',
    currencyCode: 'EUR',
    organizationCode: '75773539Q',
    roleCode: 'WCAD',
    sub: 0,
    temporalPassword: ''
  },
  configId: ''
};
